export enum BookVisitErrorModalResult {
  Unknown = 0,
  TryAgain = 1,
  ChangeVisitSlot = 2
}
